export default __webpack_public_path__ + "696c76f6929ad1994ccd09a70aaca107.png";